module.exports = __webpack_public_path__ + "static/media/DropDown.645e0382.svg";